export default __webpack_public_path__ + "static/media/note-taker.6b5a51b2.jpg";